import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-partner-detail',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './partner-detail.template.component.html',
  styleUrls: ['./partner-detail.template.component.scss']
})
export class SkeletorPartnerDetailTemplateComponent {
  @Input() items: number = 6;
  get rows() { return Array.from({ length: this.items }); }
}
